import React, { useState, useEffect } from 'react';
import { func, string, bool, shape } from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import { FormControlLabel, makeStyles } from '@material-ui/core';
import styled from 'styled-components';
import IconCheckBoxEmpty from './IconCheckBoxEmpty';
import IconCheckBoxCheck from './IconCheckBoxCheck';
import infoIconBlack from '../../../images/insight360/info-icon_black_outline.png';
import { AC_DISABLE_DIFINITION_INFO_MSG } from '../AutocodeConstants';

const CheckLabel = styled.div`
  font-weight: ${props => (props.allCheck ? 'bold' : 'normal')};
  font-size: ${props => (props.allCheck ? '14px' : '13px')};
  line-height: ${props => (props.allCheck ? '16px' : '15px')};
  color: #333333;
  width: 100%;
  word-break: break-word;
  user-select: none;
`;

const useStyles = makeStyles({
  checkBoxRoot: {
    padding: 12,
    '& .MuiSvgIcon-root': {
      fontSize: '22px !important',
    },
  },
});

const AutocodeCheckBox = ({
  onChange,
  id,
  isChecked = false,
  data = null,
  fill,
  stroke,
  opacity,
  label,
  allCheck = false,
  showLabel = true,
  disableCheck = false,
  disable = false,
}) => {
  const classes = useStyles();
  const [checked, setCheck] = useState(isChecked);

  useEffect(() => {
    // if(isChecked) {
    setCheck(isChecked);
    // }
  }, [isChecked]);

  const _handleOnChange = event => {
    setCheck(!checked);
    onChange(!checked, data || null, event);
  };

  // let classnames = 'ac--checkbox';

  // if (checked) {
  //   classnames = `${classnames} ac--checkbox__active`;
  // }
  return (
    <FormControlLabel
      control={
        <Checkbox
          data-test="AutocodeCheckBox"
          className="ac--checkbox"
          onChange={_handleOnChange}
          checked={checked}
          id={id}
          classes={{
            root: classes.checkBoxRoot,
          }}
          color="primary"
          icon={<IconCheckBoxEmpty />}
          checkedIcon={
            <IconCheckBoxCheck fill={fill} stroke={stroke} opacity={opacity} />
          }
          disabled={disableCheck || disable}
        />
      }
      label={
        showLabel && (
          <CheckLabel
            allCheck={allCheck}
            className={disableCheck === true ? 'ac-disabled-def' : ''}
          >
            {label}
            {disableCheck && (
              <span className="ac-info-span">
                <img
                  alt="info"
                  className="ac_info_icons_img"
                  title={AC_DISABLE_DIFINITION_INFO_MSG}
                  src={infoIconBlack}
                />
              </span>
            )}
          </CheckLabel>
        )
      }
    />
  );
};

AutocodeCheckBox.propTypes = {
  onChange: func.isRequired,
  id: string.isRequired,
  isChecked: bool.isRequired,
  data: shape({}),
  fill: string,
  stroke: string,
  opacity: string,
  label: string,
  allCheck: bool,
  showLabel: bool,
  disableCheck: bool,
};

export default AutocodeCheckBox;
